var _g, _path, _path2, _path3, _path4, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoRes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 178,
    viewBox: "0 0 317 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.795 105.374H207.463C202.315 105.374 198.167 100.511 198.167 95.1001C198.167 89.689 202.315 84.8259 207.463 84.8259H288.313C293.461 84.8259 297.609 80.3053 297.609 74.8942C297.609 69.4831 293.461 64.9625 288.313 64.9625H225.018C219.87 64.9625 215.722 60.7843 215.722 55.3732C215.722 49.9621 219.87 45.784 225.018 45.784H245.684C250.832 45.784 254.98 41.6058 254.98 36.1947C254.98 30.7836 250.832 26.6055 245.684 26.6055H102.799C97.6507 26.6055 93.5027 30.7836 93.5027 36.1947C93.5027 41.6058 97.6507 45.784 102.799 45.784H112.095C117.243 45.784 121.391 49.9621 121.391 55.3732C121.391 60.7843 117.243 64.9625 112.095 64.9625H41.4299C36.2818 64.9625 32.1338 69.4831 32.1338 74.8942C32.1338 80.3053 36.2818 84.8259 41.4299 84.8259H58.985C64.133 84.8259 68.2811 89.689 68.2811 95.1001C68.2811 100.511 64.096 105.374 58.985 105.374H48.6519C43.5039 105.374 39.3558 109.552 39.3558 114.964C39.3558 120.375 43.5039 124.553 48.6519 124.553H96.6137C101.762 124.553 105.91 129.073 105.91 134.485C105.91 139.896 101.762 144.416 96.6137 144.416H89.3917C84.2437 144.416 80.0956 148.594 80.0956 154.006C80.0956 159.417 84.2437 163.595 89.3917 163.595H146.205H152.427H166.871H201.278H236.203C241.351 163.595 245.499 159.417 245.499 154.006C245.499 148.594 241.351 144.416 236.203 144.416H227.944C222.796 144.416 218.648 139.896 218.648 134.485C218.648 129.073 222.796 124.553 227.944 124.553H254.795C259.943 124.553 264.091 120.375 264.091 114.964C264.091 109.552 259.943 105.374 254.795 105.374ZM167.39 45.647C167.908 45.7497 168.427 45.784 168.945 45.784H165.834C166.353 45.784 166.871 45.7155 167.39 45.647Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.682 105.374H291.127C286.053 105.374 281.905 109.621 281.905 114.963C281.905 120.306 286.016 124.553 291.127 124.553H306.682C311.756 124.553 315.904 120.306 315.904 114.963C315.867 109.621 311.756 105.374 306.682 105.374Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7257 144.416H40.3558C35.2448 144.416 31.1338 148.663 31.1338 154.005C31.1338 159.348 35.2448 163.595 40.3558 163.595H59.7627C64.8367 163.595 68.9847 159.348 68.9847 154.005C68.9477 148.663 64.8367 144.416 59.7257 144.416Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9106 45.784H77.3179C82.3918 45.784 86.5399 41.5373 86.5399 36.1947C86.5399 30.8521 82.4288 26.6055 77.3549 26.6055H72.9476C67.8366 26.6055 63.7256 30.8521 63.7256 36.1947C63.7256 41.5373 67.8366 45.784 72.9106 45.784Z",
    fill: "#F9F9F9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.916 142.65C186.566 142.65 208.315 120.901 208.315 94.2507C208.315 67.6005 186.566 45.8516 159.916 45.8516C133.266 45.8516 111.517 67.6005 111.517 94.2507C111.517 120.901 133.266 142.65 159.916 142.65ZM159.916 137.442C183.809 137.442 203.107 118.144 203.107 94.2506C203.107 70.3574 183.809 51.059 159.916 51.059C136.022 51.059 116.724 70.3574 116.724 94.2506C116.724 118.144 136.022 137.442 159.916 137.442Z",
    fill: "url(#paint0_linear_2_1036)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.213 108.036C140.213 106.629 141.353 105.488 142.76 105.488H176.149C177.556 105.488 178.697 106.629 178.697 108.036C178.697 109.442 177.556 110.583 176.149 110.583H142.76C141.353 110.583 140.213 109.442 140.213 108.036Z",
    fill: "url(#paint1_linear_2_1036)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.15 96.3948C145.195 96.3948 147.663 93.9262 147.663 90.881C147.663 87.8358 145.195 85.3672 142.15 85.3672C139.104 85.3672 136.636 87.8358 136.636 90.881C136.636 93.9262 139.104 96.3948 142.15 96.3948Z",
    fill: "url(#paint2_linear_2_1036)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.378 96.3948C180.423 96.3948 182.892 93.9262 182.892 90.881C182.892 87.8358 180.423 85.3672 177.378 85.3672C174.333 85.3672 171.864 87.8358 171.864 90.881C171.864 93.9262 174.333 96.3948 177.378 96.3948Z",
    fill: "url(#paint3_linear_2_1036)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2_1036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5429 52.0756C14.9546 52.0756 12.8594 49.9811 12.8594 47.3938C12.8594 44.8064 14.9546 42.7119 17.5429 42.7119C20.1311 42.7119 22.2264 44.8064 22.2264 47.3938C22.2264 49.9811 20.1311 52.0756 17.5429 52.0756ZM17.5429 44.3547C15.8585 44.3547 14.5027 45.7099 14.5027 47.3938C14.5027 49.0776 15.8585 50.4329 17.5429 50.4329C19.2273 50.4329 20.5831 49.0776 20.5831 47.3938C20.5831 45.7099 19.2273 44.3547 17.5429 44.3547Z",
    fill: "url(#paint4_linear_2_1036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.965 177.747C296.377 177.747 294.281 175.652 294.281 173.065C294.281 170.477 296.377 168.383 298.965 168.383C301.553 168.383 303.648 170.477 303.648 173.065C303.648 175.652 301.553 177.747 298.965 177.747ZM298.965 170.026C297.28 170.026 295.925 171.381 295.925 173.065C295.925 174.749 297.28 176.104 298.965 176.104C300.649 176.104 302.005 174.749 302.005 173.065C302.005 171.381 300.649 170.026 298.965 170.026Z",
    fill: "url(#paint5_linear_2_1036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.317 9.36372C218.729 9.36372 216.634 7.2692 216.634 4.68186C216.634 2.09452 218.729 0 221.317 0C223.906 0 226.001 2.09452 226.001 4.68186C226.001 7.2692 223.906 9.36372 221.317 9.36372ZM221.317 1.64276C219.633 1.64276 218.277 2.99803 218.277 4.68186C218.277 6.36569 219.633 7.72096 221.317 7.72096C223.002 7.72096 224.357 6.36569 224.357 4.68186C224.357 2.99803 223.002 1.64276 221.317 1.64276Z",
    fill: "url(#paint6_linear_2_1036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.407 35.401C98.9289 35.401 95.2725 31.7459 95.2725 27.2694C95.2725 22.7928 98.9289 19.1377 103.407 19.1377C107.885 19.1377 111.542 22.7928 111.542 27.2694C111.542 31.7459 107.885 35.401 103.407 35.401ZM103.407 20.7805C99.8327 20.7805 96.9158 23.6964 96.9158 27.2694C96.9158 30.8423 99.8327 33.7582 103.407 33.7582C106.981 33.7582 109.898 30.8423 109.898 27.2694C109.898 23.6964 106.981 20.7805 103.407 20.7805Z",
    fill: "url(#paint7_linear_2_1036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5116 130.107C28.9234 130.107 26.8281 128.012 26.8281 125.425C26.8281 122.838 28.9234 120.743 31.5116 120.743C34.0999 120.743 36.1952 122.838 36.1952 125.425C36.1952 128.012 34.0999 130.107 31.5116 130.107ZM31.5116 122.386C29.8272 122.386 28.4715 123.741 28.4715 125.425C28.4715 127.109 29.8272 128.464 31.5116 128.464C33.1961 128.464 34.5518 127.109 34.5518 125.425C34.5518 123.741 33.1961 122.386 31.5116 122.386Z",
    fill: "url(#paint8_linear_2_1036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.376 160.004L165.567 155.815C165.896 155.487 165.896 154.994 165.567 154.665C165.238 154.337 164.745 154.337 164.417 154.665L160.226 158.854L156.036 154.665C155.707 154.337 155.214 154.337 154.885 154.665C154.557 154.994 154.557 155.487 154.885 155.815L159.076 160.004L154.885 164.193C154.557 164.522 154.557 165.015 154.885 165.343C155.05 165.508 155.255 165.59 155.46 165.59C155.666 165.59 155.871 165.508 156.036 165.343L160.226 161.154L164.417 165.343C164.581 165.508 164.786 165.59 164.992 165.59C165.197 165.59 165.403 165.508 165.567 165.343C165.896 165.015 165.896 164.522 165.567 164.193L161.376 160.004Z",
    fill: "url(#paint9_linear_2_1036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.362 109.079L299.416 107.025C299.745 106.697 299.745 106.204 299.416 105.875C299.088 105.547 298.595 105.547 298.266 105.875L296.212 107.929L294.199 105.875C293.87 105.547 293.377 105.547 293.048 105.875C292.72 106.204 292.72 106.697 293.048 107.025L295.061 109.079L293.048 111.091C292.72 111.42 292.72 111.912 293.048 112.241C293.213 112.405 293.418 112.487 293.623 112.487C293.829 112.487 294.034 112.405 294.199 112.241L296.212 110.229L298.266 112.241C298.43 112.405 298.636 112.487 298.841 112.487C299.046 112.487 299.252 112.405 299.416 112.241C299.745 111.912 299.745 111.42 299.416 111.091L297.362 109.079Z",
    fill: "url(#paint10_linear_2_1036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.484 35.566L167.538 33.5126C167.867 33.184 167.867 32.6912 167.538 32.3626C167.21 32.0341 166.717 32.0341 166.388 32.3626L164.334 34.4161L162.321 32.3626C161.992 32.0341 161.499 32.0341 161.17 32.3626C160.842 32.6912 160.842 33.184 161.17 33.5126L163.183 35.566L161.17 37.5784C160.842 37.9069 160.842 38.3998 161.17 38.7283C161.335 38.8926 161.54 38.9747 161.746 38.9747C161.951 38.9747 162.156 38.8926 162.321 38.7283L164.334 36.7159L166.388 38.7283C166.552 38.8926 166.758 38.9747 166.963 38.9747C167.168 38.9747 167.374 38.8926 167.538 38.7283C167.867 38.3998 167.867 37.9069 167.538 37.5784L165.484 35.566Z",
    fill: "url(#paint11_linear_2_1036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.732 20.6577C296.376 20.6577 295.308 19.5488 295.308 18.2346C295.308 16.9204 296.417 15.8115 297.732 15.8115C299.087 15.8115 300.155 16.9204 300.155 18.2346C300.155 19.5488 299.087 20.6577 297.732 20.6577ZM297.732 16.6329C296.828 16.6329 296.129 17.3721 296.129 18.2346C296.129 19.1381 296.869 19.8363 297.732 19.8363C298.635 19.8363 299.334 19.097 299.334 18.2346C299.334 17.3311 298.635 16.6329 297.732 16.6329Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.576 95.4038C313.221 95.4038 312.152 94.2949 312.152 92.9807C312.152 91.6254 313.262 90.5576 314.576 90.5576C315.932 90.5576 317 91.6665 317 92.9807C317 94.2949 315.932 95.4038 314.576 95.4038ZM314.576 91.379C313.672 91.379 312.974 92.1182 312.974 92.9807C312.974 93.8842 313.714 94.5824 314.576 94.5824C315.48 94.5824 316.179 93.8431 316.179 92.9807C316.179 92.0772 315.48 91.379 314.576 91.379Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.466 150.025C180.357 150.025 179.453 149.121 179.453 148.012C179.453 146.904 180.357 146 181.466 146C182.575 146 183.479 146.904 183.479 148.012C183.479 149.121 182.575 150.025 181.466 150.025ZM181.466 146.821C180.809 146.821 180.275 147.355 180.275 148.012C180.275 148.669 180.809 149.203 181.466 149.203C182.124 149.203 182.658 148.669 182.658 148.012C182.658 147.355 182.124 146.821 181.466 146.821Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6869 13.6761C82.5777 13.6761 81.6738 12.7726 81.6738 11.6637C81.6738 10.5549 82.5777 9.65137 83.6869 9.65137C84.7962 9.65137 85.7 10.5549 85.7 11.6637C85.7 12.7726 84.7962 13.6761 83.6869 13.6761ZM83.6869 10.4727C83.0296 10.4727 82.4955 11.0066 82.4955 11.6637C82.4955 12.3209 83.0296 12.8547 83.6869 12.8547C84.3443 12.8547 84.8784 12.3209 84.8784 11.6637C84.8784 11.0066 84.3443 10.4727 83.6869 10.4727Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.976 155.364C32.8667 155.364 31.9629 154.46 31.9629 153.351C31.9629 152.242 32.8667 151.339 33.976 151.339C35.0852 151.339 35.9891 152.242 35.9891 153.351C35.9891 154.46 35.0852 155.364 33.976 155.364ZM33.976 152.16C33.3186 152.16 32.7846 152.694 32.7846 153.351C32.7846 154.008 33.3186 154.542 33.976 154.542C34.6333 154.542 35.1674 154.008 35.1674 153.351C35.1674 152.694 34.6333 152.16 33.976 152.16Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.356 8.66579L135.781 8.09082L134.302 9.52823L132.864 8.09082L132.289 8.66579L133.727 10.1032L132.289 11.5817L132.864 12.1566L134.302 10.6782L135.781 12.1566L136.356 11.5817L134.918 10.1032L136.356 8.66579Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.248 152.407L313.673 151.832L312.194 153.269L310.756 151.832L310.181 152.407L311.619 153.844L310.181 155.323L310.756 155.898L312.194 154.419L313.673 155.898L314.248 155.323L312.81 153.844L314.248 152.407Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46 15.8922L234.974 19.377L235.555 19.9577L239.041 16.473L238.46 15.8922Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.555 15.8928L234.974 16.4736L238.46 19.9584L239.041 19.3776L235.555 15.8928Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06726 111.749L3.49209 111.174L2.01309 112.611L0.575169 111.174L0 111.749L1.43792 113.186L0 114.665L0.575169 115.24L2.01309 113.761L3.49209 115.24L4.06726 114.665L2.62934 113.186L4.06726 111.749Z",
    fill: "#58C6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1122 53.4314L35.537 52.8564L34.058 54.2939L32.6201 52.8564L32.0449 53.4314L33.4828 54.8688L32.0449 56.3473L32.6201 56.9223L34.058 55.4438L35.537 56.9223L36.1122 56.3473L34.6743 54.8688L36.1122 53.4314Z",
    fill: "#58C6FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1036",
    x1: 159.916,
    y1: 45.8516,
    x2: 159.916,
    y2: 142.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F4D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1036",
    x1: 159.455,
    y1: 86.6091,
    x2: 159.455,
    y2: 118.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F4D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1036",
    x1: 142.15,
    y1: 85.3672,
    x2: 142.15,
    y2: 96.3948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F4D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1036",
    x1: 177.378,
    y1: 85.3672,
    x2: 177.378,
    y2: 96.3948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9F4D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1036",
    x1: 17.5429,
    y1: 42.7119,
    x2: 17.5429,
    y2: 52.0756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_1036",
    x1: 298.965,
    y1: 168.383,
    x2: 298.965,
    y2: 177.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_1036",
    x1: 221.317,
    y1: 0,
    x2: 221.317,
    y2: 9.36372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_1036",
    x1: 103.407,
    y1: 19.1377,
    x2: 103.407,
    y2: 35.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_1036",
    x1: 31.5116,
    y1: 120.743,
    x2: 31.5116,
    y2: 130.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_1036",
    x1: 160.226,
    y1: 154.419,
    x2: 160.226,
    y2: 165.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_1036",
    x1: 296.232,
    y1: 105.629,
    x2: 296.232,
    y2: 112.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_1036",
    x1: 164.354,
    y1: 32.1162,
    x2: 164.354,
    y2: 38.9747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9F4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C6FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284.734,
    height: 136.989,
    fill: "white",
    transform: "translate(31.1338 26.6055)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_1036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317,
    height: 177.746,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRes);
export default __webpack_public_path__ + "static/media/no_res.c7f604a1c0913a62872f58e6bf846a99.svg";
export { ForwardRef as ReactComponent };